import messages from '../../../locale/messages'
import { inputTextLimit } from '../../../helpers/FieldRestriction';

const validate = values => {

  let errors = {};

  let description = values && values.description && values.description.replace('<p>', '').replace('</p>', '')
  const stripped = values?.description.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, "").replace(/\s+/g, "").trim();

  if (!values.description || description.trim() === "" || values.description === '<p><br></p>' || !stripped) {
    errors.description = messages.required;
  }

  if (!values.title || values.title.trim() === "") {
    errors.title = messages.required;
  } else if (values.title.length > inputTextLimit) {
    errors.title = messages.inputTextLimitError;
  }

  if (!values.isEnabled) {
    errors.isEnabled = messages.required;
  }

  return errors
}

export default validate;